import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportExternalPagesRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-external-pages',
	path: '/secure/admin/Importer(\\w+)Page([!%]?[\\w]*).jspa',
};
